import React, { useMemo } from "react";

import { PrivateRoute, PrivateRouteProps } from "App/router";
import { FourOhThree } from "shared/pages";
import { IPermissionForKey, IPermissionKey } from "shared/types";
import { userHasPermission } from "shared/utils";

interface PermissionsRouteProps extends PrivateRouteProps {
  permissions?: IPermissionForKey[];
  permissionType?: IPermissionKey;
}

/*
  This component redirects to the 404 page when the user does not have the correct permissions to access the route.
*/
export const PermissionsRoute: React.FC<PermissionsRouteProps> = ({
  component: Component,
  permissions,
  permissionType,
  ...rest
}) => {
  const userHasPermissions: boolean = useMemo(
    () => userHasPermission(permissions, permissionType),
    [permissions, permissionType]
  );

  if (!permissions || permissions?.length === 0) {
    return <FourOhThree />;
  }

  return (
    <PrivateRoute
      {...rest}
      component={userHasPermissions ? Component : () => <FourOhThree />}
    />
  );
};
